import { useState } from "react";
import { ButtonComp } from "../../../../components";
import TextEditor from "../../modules/TextEditor";

const MessageForm = ({ title, onBack, onProceed, initialMessage = "" }) => {
  const [message, setMessage] = useState(initialMessage);
  
  const handleSubmit = () => {
    if (message && message.length > 3) {
      onProceed(message);
    }
  };

  return (
    <div className="py-2">
      <h5 className="fw-bold mb-4 text-center">{title}</h5>
      
      <div className="mb-4">
        <label className="small fw-bold mb-2 text-blacklight">Message Template</label>
        <div className="border rounded-4 overflow-hidden">
          <TextEditor 
            initialValue={initialMessage} 
            handleContentChange={setMessage} 
          />
        </div>
        <p className="small text-blacklight mt-2">
          Use placeholders like <b>{"{first_name}"}</b>, <b>{"{last_name}"}</b>, and <b>{"{company_name}"}</b> to personalize the message.
        </p>
      </div>

      <div className="row justify-content-between mt-4">
        <div className="col-5">
          <ButtonComp
            btnText={"Cancel"}
            ButtonInlineStyle={{ borderRadius: "10px" }}
            btnClassName={"text-primary1 btn w-100 py-3 border-primary1"}
            onClick={() => onBack()}
          />
        </div>
        <div className="col-5">
          <ButtonComp
            btnText={"Submit"}
            ButtonInlineStyle={{
              backgroundColor: "var(--color-primary)",
              borderRadius: "10px",
            }}
            btnClassName={"border-0 text-white w-100 py-3"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default MessageForm;

